<template>
    <div class="mod-config">
        <el-card body-style="padding-bottom: 0;" style="margin-top: -5px;">
            <div class="title">进度详情记录</div>
            <div class="line"></div>
            <el-row style="margin-top: -10px;margin-left: -20px;width: 100%; line-height:30px;">
                <el-row v-if="showSubject">
                    <el-col :span="2">
                        <div class="search_title">标的物</div>
                    </el-col>
                    <el-col :span="22" style="display: flex;flex-wrap: wrap;">
                        <span v-for="(subject, index) in subjectList" :key="'sub' + index" style="margin-right: 20px;">
                            <span class="search_sec_bn_border"
                                v-if="subjectNo === subject.displayValue && subject.displayName == '全部'"
                                @click="setSubject(subject)">
                                {{ subject.displayName }}
                            </span>
                            <span class="search_sec_bn"
                                v-else-if="subjectNo !== subject.displayValue && subject.displayName == '全部'"
                                @click="setSubject(subject)">
                                {{ subject.displayName }}
                            </span>
                            <span class="search_bn_border"
                                v-if="subjectNo === subject.displayValue && subject.displayName != '全部'"
                                @click="setSubject(subject)">
                                {{ subject.displayName }}
                            </span>
                            <span class="search_bn"
                                v-else-if="subjectNo !== subject.displayValue && subject.displayName != '全部'"
                                @click="setSubject(subject)">
                                {{ subject.displayName }}
                            </span>
                        </span>
                    </el-col>
                </el-row>
                <el-row style="margin-top: 2px;">
                    <el-col :span="2">
                        <div class="search_title">专业</div>
                    </el-col>
                    <el-col :span="22" style="display: flex;flex-wrap: wrap;">
                        <span v-for="(maj, index) in allMajorList" :key="'pk' + index" style="margin-right: 20px;">
                            <span class="search_sec_bn_border" v-if="major === maj.displayValue" @click="setMajor(maj)">
                                {{ maj.displayName }}
                            </span>
                            <span class="search_sec_bn" v-else-if="major !== maj.displayValue" @click="setMajor(maj)">
                                {{ maj.displayName }}
                            </span>
                        </span>
                    </el-col>
                </el-row>
            </el-row>
            <div class="line" style="margin-top: 0px;"></div>
            <el-row>
                <el-row
                    style="background-color: rgb(243, 247, 247);margin-top: -10px;height: 45px;width: 103%;margin-left: -20px;">
                    <el-col :span="11" style="margin-left:15px;margin-top:5px">
                        <el-button v-preventReClick class="btn" type="primary" size="small"
                            :disabled="updateFlg || addFlg" @click="addHandle()">新增</el-button>
                        <!-- <el-button v-preventReClick class="btn" type="primary" size="small" 
                            :disabled="updateFlg || addFlg" @click="downloadHandle()">导出</el-button> -->
                        <el-button v-preventReClick :disabled="disabledBatchDelete || updateFlg || addFlg" class="btn"
                            type="primary" size="small" @click="deleteBatch()">批量删除</el-button>
                    </el-col>
                </el-row>
                <div class="line" style="margin-top: -4px;"></div>
                <el-form ref="form" :model="form" inline label-width="55px" label-position="left">
                    <el-row
                        style="background-color: rgb(243, 247, 247);margin-top: -10px;margin-left: -20px;height: 45px;width: 103%;">
                        <el-col :span="20">
                            <el-form-item label="时间" class="selFormItem2" style="margin-top:2px">
                                <el-date-picker class="selDateInput" v-model="recordTime" type="daterange"
                                    range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" clearable
                                    value-format="yyyy-MM-dd" :disabled="updateFlg || addFlg">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item label="内容" class="selFormItem2">
                                <el-input class="selSearchInput" v-model="context" :disabled="updateFlg || addFlg"
                                    clearable></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" class="selBtnGroup">
                            <el-button style="margin-top:2px" v-preventReClick class="btn" type="primary" size="small"
                                @click="selGetDataList()" :disabled="updateFlg || addFlg">查询</el-button>
                            <el-button v-preventReClick class="rebtn" size="small" :disabled="updateFlg || addFlg"
                                @click="resetFormData()">重置</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-row>
        </el-card>
        <div>
            <el-card style="margin-top: -30px;" body-style="padding: 0;">
                <el-row style="margin-bottom: 10px;">
                    <el-col :span="24">
                        <div class="box">
                            <el-table :height="getTableHeight()" :row-style="selectRowBackground"
                                :row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable"
                                :data="dataList" header-align="center" header-cell-class-name="dataListTHeader"
                                @selection-change="handleSelectionChange" :cell-style="{ padding: '0px' }"
                                style="margin-bottom: 20px;">
                                <el-table-column type="selection" width="45" align="center"></el-table-column>
                                <el-table-column type="index" label="No." width="70" align="center"></el-table-column>
                                <el-table-column prop="recordTime" label="时间 " width="114" align="center">
                                    <template slot-scope="scope">
                                        <span style="margin-left: 15px;" v-if="!getDisabled(scope.row.recNo)">
                                            {{ scope.row.recordTime }}
                                        </span>
                                        <!-- 修改状态下的日期选择器 -->
                                        <el-date-picker class="sp-input small-date-picker"
                                            v-model="scope.row.recordTime" type="date" value-format="yyyy-MM-dd"
                                            placeholder="选择日期" style="width: 140px;"
                                            v-if="getDisabled(scope.row.recNo)">
                                        </el-date-picker>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="inspectionKind" label="专业" width="150" header-align="center"
                                    align="left">
                                    <template slot-scope="scope">
                                        <span v-if="!getDisabled(scope.row.recNo)"
                                            style=" border-bottom: 1px solid transparent;">
                                            {{ scope.row.majorName }}
                                        </span>
                                        <el-select class="sp-input small-select right-arrow" v-model="scope.row.major"
                                            placeholder="请选择" v-if="getDisabled(scope.row.recNo)" style="width: 130px"
                                            clearable>
                                            <el-option v-for="item in majorList" :key="item.displayValue"
                                                :label="item.displayName" :value="item.displayValue">
                                            </el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="context" label="内容" align="left" min-width="250"
                                    show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span v-if="!getDisabled(scope.row.recNo)">{{ scope.row.context }}</span>
                                        <el-input class="sp-input small-input" v-if="getDisabled(scope.row.recNo)"
                                            v-model="scope.row.context"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="recordMan" label="记录人" align="left" width="100"
                                    show-overflow-tooltip>
                                    <template slot-scope="scope">
                                        <span style="cursor: pointer;" v-if="!getDisabled(scope.row.recNo)"
                                            @click="lookInfoHandle(scope.row.recNo)">{{ scope.row.recordMan }}</span>
                                        <el-input class="sp-input small-input" v-if="getDisabled(scope.row.recNo)"
                                            v-model="scope.row.recordMan"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column label="操作" width="100" align="left" fixed="right">
                                    <template slot-scope="scope">
                                        <el-button v-preventReClick type="text" size="mini"
                                            @click="updateHandle(scope.row.recNo)"
                                            v-if="!updateFlg && !addFlg">修改</el-button>
                                        <el-button v-preventReClick type="text" size="mini"
                                            @click="deleteHandle(scope.row.recNo)"
                                            v-if="!updateFlg && !addFlg">删除</el-button>
                                        <!--新增时按钮-->
                                        <el-button v-preventReClick type="text" size="small"
                                            @click="saveProgressRecord()"
                                            v-if="scope.row.recNo == undefined && addFlg">保存</el-button>
                                        <el-button v-preventReClick type="text" size="small" @click="cancelSaveHandle()"
                                            v-if="scope.row.recNo == undefined && addFlg">取消</el-button>
                                        <!--修改时按钮-->
                                        <el-button v-preventReClick type="text" size="small"
                                            @click="updateProgressRecord(scope.row)"
                                            v-if="getDisabled(scope.row.recNo) && !addFlg">保存</el-button>
                                        <el-button v-preventReClick type="text" size="small"
                                            @click="cancelUpdateHandle()"
                                            v-if="getDisabled(scope.row.recNo) && !addFlg">取消</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                        <el-pagination class="my-pagination" @size-change="sizeChangeHandle"
                            @current-change="currentChangeHandle" :current-page="pageIndex"
                            :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
                            layout="total, sizes, prev, pager, next, jumper" :disabled="updateFlg || addFlg">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-card>
        </div>
    </div>
</template>
<script>
import $common from "@/utils/common.js"
export default {
    data() {
        return {
            disabledBatchDelete: true,
            updateFlg: false,
            showSubject: false,
            addFlg: false,
            tableSelVals: [],
            recordTime: [],
            context: '',
            form: {},
            //当前页码
            pageIndex: 1,
            //当前记录数
            pageSize: 20,
            //总页数
            totalPage: 0,
            workNo: $common.getItem("workNo"),
            tableSelVal: [],
            majorList: [],
            allMajorList: [],
            checkIdList: [],
            dataList: [],
            recNos: [],
            major: '',
            subjectNo: '',
        };
    },
    computed: {
    },
    components: {
    },
    mounted() {
        this.screenHeight = window.innerHeight
        this.getAllSubjectDropDown()
        this.getMajorByWorkNo();
        this.getAllMajorByWorkNo();
    },
    filters: {
    },
    methods: {
        getTableHeight() {
            if (this.showSubject) {
                return this.screenHeight - 298 + 'px';
            }
            return this.screenHeight - 270 + 'px';
        },
        getCurrentTime() {
            //获取当前时间并打印
            var _this = this;
            let yy = new Date().getFullYear();
            let mm = new Date().getMonth() + 1;
            let dd = new Date().getDate();
            let hh = new Date().getHours();
            let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
            let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
            return yy + '-' + mm + '-' + dd;
        },
        addHandle() {
            if (this.subjectNo == undefined || this.subjectNo == '') {
                this.$message.error("请选择标的物！")
                return;
            }
            // 首行新增一条记录
            let dataList = [];
            let testRecord = {
                workNo: $common.getItem("workNo"),
                subjectNo: this.subjectNo,
                major: this.major,
                context: '',
                recordTime: this.getCurrentTime(),
                recordMan: $common.getItem("userName"),
            }
            dataList.push(testRecord);
            for (var i = 0; i < this.dataList.length; i++) {
                dataList.push(this.dataList[i])
            }
            this.dataList = dataList
            this.addFlg = true;
        },
        cancelSaveHandle() {
            this.addFlg = false;
            let dataList = [];
            for (var i = 0; i < this.dataList.length; i++) {
                if (this.dataList[i].recNo != undefined) {
                    dataList.push(this.dataList[i])
                }
            }
            this.dataList = dataList
        },
        updateHandle(recNo) {
            this.recNos.push(recNo);
            this.updateFlg = true;
        },
        cancelUpdateHandle() {
            this.getDataList();
            this.recNos = [];
            this.updateFlg = false;
        },
        // 判断是否可编辑 - 修改时用
        getDisabled(val) {
            if (val == '' || val == undefined) {
                return true;
            } else {
                // 只在修改状态下才可编辑
                if (this.recNos.includes(val) && this.updateFlg) {
                    return true;
                }
                return false;
            }
        },
        // 获取数据列表
        getDataList() {
            // if(this.recordTime == null) {
            //     this.recordTime = []
            // }
            this.$http({
                url: this.$store.state.httpUrl + "/business/progressrecordsh/list",
                method: 'get',
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize,
                    major: this.major,
                    subjectNo: this.subjectNo,
                    recordTimeBegin: this.recordTime && this.recordTime[0] ? this.recordTime[0] : "",
                    recordTimeEnd: this.recordTime && this.recordTime[1] ? this.recordTime[1] : "",
                    workNo: $common.getItem("workNo"),
                    context: this.context,
                })
            }).then(({
                data
            }) => {
                if (data && data.resultCode === 200) {
                    this.dataList = data.body.recordList;
                    this.totalPage = data.body.totalCount;
                } else {
                    this.dataList = []
                    this.totalPage = 0
                }
            })
        },
        saveProgressRecord() {
            if (this.dataList[0].subjectNo == null || this.dataList[0].subjectNo == "") {
                this.$message.error("请选择标的物");
                return;
            }

            if (this.dataList[0].major == null || this.dataList[0].major == "") {
                this.$message.error("请选择专业");
                return;
            }

            if (this.dataList[0].recordTime == null || this.dataList[0].recordTime == "") {
                this.$message.error("请填写检验时间");
                return;
            }

            if (this.dataList[0].recordMan == null || this.dataList[0].recordMan == "") {
                this.$message.error("请填写记录人");
                return;
            }

            let _url = "/business/progressrecordsh/save";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData(this.dataList[0])
            }).then(({
                data
            }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                    });
                    this.getDataList()
                    this.addFlg = false
                }
            });
        },
        updateProgressRecord(val) {
            if (val.subjectNo == null || val.subjectNo == "") {
                this.$message.error("请选择标的物");
                return;
            }

            if (val.major == null || val.major == "") {
                this.$message.error("请选择专业");
                return;
            }

            if (val.recordTime == null || val.recordTime == "") {
                this.$message.error("请填写检验时间");
                return;
            }

            if (val.recordMan == null || val.recordMan == "") {
                this.$message.error("请填写记录人");
                return;
            }

            let _url = "/business/progressrecordsh/update";
            this.$http({
                url: this.$store.state.httpUrl + _url,
                method: "post",
                data: this.$http.adornData(val)
            }).then(({
                data
            }) => {
                if (data && data.resultCode === 200) {
                    this.$message({
                        message: "操作成功",
                        type: "success",
                        duration: 1500,
                    });
                    this.getDataList();
                    this.updateFlg = false;
                    this.recNos = [];
                }
            });
        },
        getAllSubjectDropDown() {
            this.$http({
                url: this.$store.state.httpUrl + "/common/getAllSubjectDropDown/" + $common.getItem("workNo"),
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.subjectList = data.body;
                    if (this.subjectList != undefined && this.subjectList.length > 0) {
                        this.subjectNo = this.subjectList[0].displayValue
                    }
                    this.getDataList();
                    if (this.subjectList != undefined && this.subjectList.length > 1) {
                        this.showSubject = true
                    } else {
                        this.showSubject = false
                    }
                }
            });
        },
        //获取类型
        getAllMajorByWorkNo() {
            this.$http({
                url: this.$store.state.httpUrl + "/common/getAllMajorByWorkNo/" + $common.getItem("workNo"),
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.allMajorList = data.body;
                    if (this.allMajorList != undefined && this.allMajorList.length > 0) {
                        this.major = this.allMajorList[0].displayValue
                        this.getDataList();
                    }
                }
            });
        },
        //获取类型
        getMajorByWorkNo() {
            this.$http({
                url: this.$store.state.httpUrl + "/common/getMajorByWorkNo/" + $common.getItem("workNo"),
                method: "get",
                params: {},
            }).then(({ data }) => {
                if (data && data.resultCode === 200) {
                    this.majorList = data.body;
                }
            });
        },
        setMajor(maj) {
            if (!this.addFlg && !this.updateFlg) {
                this.major = maj.displayValue
                this.getDataList()
            }
        },
        setSubject(subject) {
            if (!this.addFlg && !this.updateFlg) {
                this.subjectNo = subject.displayValue
                this.getDataList()
            }
        },
        siteContentViewHeight() {
            var height = this.$store.state.common.documentClientHeight - 320;
            return {
                height: height + 'px'
            }
        },
        handleSelectionChange(selection) {
            this.tableSelVals = selection;
            if (selection.length > 0) {
                this.disabledBatchDelete = false;
            } else {
                this.disabledBatchDelete = true;
            }
        },
        deleteHandle(id) {
            this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    url: this.$store.state.httpUrl + "/business/progressrecordsh/delete/" + id,
                    method: 'post',
                    data: this.id,
                }).then(({
                    data
                }) => {
                    if (data && data.resultCode === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    }
                })
            });
        },
        deleteBatch() {
            this.$confirm(`确定对选中的数据进行删除操作？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let records = this.tableSelVals.map((item) => item.recNo);
                this.$http({
                    url: this.$store.state.httpUrl + "/business/progressrecordsh/deleteBatch",
                    method: 'post',
                    data: this.$http.adornData({
						records: records
					})
                }).then(({ data }) => {
                    if (data && data.resultCode === 200) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    }
                });
            });
        },
        resetFormData() {
            this.context = "";
            this.recordTime = [];
            this.selGetDataList()
        },
        selGetDataList() {
            this.pageIndex = 1;
            this.getDataList();
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        tableRowClassName({ row, rowIndex }) {
            return $common.tableRowClassName({ row, rowIndex });
        },
        selectRowBackground({ row }) {
            const checkIdList = this.tableSelVals.map((item) => item.recNo);
            if (checkIdList.includes(row.recNo)) {
                return {
                    backgroundColor: "#fae8cb",
                };
            }
        },
        downloadHandle() {
            const rLoading = this.openLoading();
            this.$http({
                url: this.$store.state.httpUrl + "/business/progressrecordsh/download",
                method: 'get',
                params: this.$http.adornParams({
                    major: this.major,
                    subjectNo: this.subjectNo,
                    recordTimeBegin: this.recordTime && this.recordTime[0] ? this.recordTime[0] : "",
                    recordTimeEnd: this.recordTime && this.recordTime[1] ? this.recordTime[1] : "",
                    workNo: $common.getItem("workNo"),
                    context: this.context,
                })
            }).then(({ data }) => {
                rLoading.close();
                if (data && data.resultCode === 200) {
                    if (this.$store.state.showTestFlag) {
                        if (data.body != null && data.body.length > 0) {
                            for (var i = 0; i < data.body.length; i++) {
                                window.open(data.body[i].fileUri)
                            }
                        }
                    } else {
                        if (data.body != null && data.body.length > 0) {
                            for (var i = 0; i < data.body.length; i++) {
                                this.global.downLoadFile(data.body[i].fileUri, data.body[i].subjectName + '巡视记录表.xlsx');
                            }
                        }
                    }
                } else {
                }
            })
        },
    }
};
</script>
<style scoped="scoped">
.selItemText {
    font-size: 14px;
    color: #1c1c1c;
    display: inline-block;
    width: 80px;
}

.my-pagination {
    margin-right: 20px !important;
    margin-top: -10px !important;
}

/* 表格样式补充 */
::v-deep(.el-table th.el-table__cell) {
    padding: 0 0px !important;
    /* 表头左右内边距改为2px，上下保持0 */
    height: 15px !important;
    line-height: 15px !important;
}

::v-deep(.el-table .el-table__row .el-table__cell) {
    font-size: 12px !important;
    height: auto !important;
    padding: 0 0px !important;
    /* 单元格左右内边距强制设为2px（核心修改） */
    line-height: 15px !important;
    white-space: normal !important;
    word-break: break-all !important;
}

/* 去除表格边框间距 */
::v-deep(.el-table) {
    border-collapse: collapse !important;
}

::v-deep(.el-table__header-wrapper) {
    border-bottom: 0px solid #EBEEF5 !important;
}

::v-deep(.el-table__body-wrapper) {
    border-top: none !important;
    z-index: 2
}

.sp-input /deep/ .el-textarea__inner {
    font-size: 12px;
    min-height: 30px !important;
    /* 最小高度 */
    line-height: 15px !important;
    padding: 5px 8px !important;
}

/* 使用更具体的选择器路径并添加 !important */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item {
    font-size: 12px !important;
    height: 30px !important;
    line-height: 30px !important;
    padding: 0 10px !important;
}

/* 也可以单独为hover状态设置 */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item:hover {
    font-size: 12px !important;
}

/* 确保所有下拉框都应用 */
::v-deep .el-select-dropdown {
    font-size: 12px !important;
}

/* 表格内的选择器需要更具体 */
.dataListTable .sp-input ::v-deep .el-select-dropdown__item {
    font-size: 12px !important;
}

/* 或者使用属性选择器增加特异性 */
.el-select-dropdown__item[data-v-76e66394] {
    font-size: 12px !important;
}

/* 若需要同时调整输入框内的字体 */
::v-deep .el-select .el-input__inner {
    font-size: 12px !important;
}

.sp-input /deep/ .el-select .el-input__inner {
    font-size: 12px;
}

.sp-input /deep/ .el-select-dropdown__item {
    font-size: 12px;
}

.sp-input /deep/ .el-textarea__inner {
    font-size: 12px;
}

.selSubjectInput /deep/ .el-input__inner {
    width: 120px !important;
    height: 30px !important;
}

.selDateInput {
    width: 270px !important;
    margin-top: 3px;
    height: 30px;
}

.selSearchInput /deep/ .el-input__inner {
    width: 200px !important;
    height: 30px !important;
    font-size: 12px;
}

.selDateInput /deep/ .el-range-separator {
    width: 40px !important;
    margin-top: -8px;
}

.selFormItem::v-deep .el-form-item__label {
    font-size: smaller;
}

.selFormItem2::v-deep .el-form-item__label {
    font-size: smaller;
    width: 80px !important;
    text-align: right;
    margin-left: -26px;
    margin-top: -1px
}

.box {
    height: 100%;
    overflow: auto;
}

.sp-input.small-select ::v-deep .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
    font-size: 12px !important;
    padding-right: 5px !important;
    width: 130px !important;
}

.sp-input.small-select ::v-deep .el-input__suffix {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.sp-input.small-select ::v-deep .el-input__icon {
    line-height: 30px !important;
    height: 30px !important;
}

.sp-input.small-date-picker ::v-deep .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
    font-size: 12px !important;
    padding-left: 25px !important;
    /* 给图标留出空间 */
    padding-right: 0 !important;
    display: flex !important;
    align-items: center !important;
}

.sp-input.small-date-picker ::v-deep .el-input__prefix {
    left: 0 !important;
    width: 20px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    height: 100% !important;
    top: 0 !important;
}

.sp-input.small-date-picker ::v-deep .el-input__icon {
    line-height: 1 !important;
    height: auto !important;
    font-size: 14px !important;
}

.sp-input.small-input ::v-deep .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
    font-size: 12px !important;
    min-height: 30px !important;
    margin-left: -10px;
}

::v-deep(.el-table .el-table__cell) {
    height: auto !important;
    min-height: 30px !important;
}

::v-deep(.el-table__body .el-input__inner) {
    width: 220px !important;
}

::v-deep(.el-table__row) {
    height: auto !important;
    min-height: 30px !important;
}

/* 移除所有边框，只保留底部边框 */
.sp-input.small-select ::v-deep .el-input__inner,
.sp-input.small-date-picker ::v-deep .el-input__inner,
.sp-input.small-input ::v-deep .el-input__inner,
.sp-input ::v-deep .el-textarea__inner {
    border: none !important;
    border-radius: 0 !important;
    background-color: transparent !important;
    padding-left: 0 !important;
    box-shadow: none !important;
}

.el-date-editor ::v-deep .el-range__icon {
    line-height: 27px;
}

.sp-input.small-date-picker ::v-deep .el-input__inner {
    padding-left: 25px !important;
    /* 调整日期图标位置 */
    padding-right: 0 !important;
}

/* 调整el-date-picker前缀图标位置 */
.sp-input.small-date-picker ::v-deep .el-input__prefix {
    left: 0 !important;
    width: 20px !important;
}

/* 调整textarea底部边框 */
.sp-input ::v-deep .el-textarea__inner {
    min-height: 30px !important;
    line-height: 15px !important;
    padding: 5px 0 !important;
    resize: none !important;
    /* 禁止拖拽 */
}

/* 确保表格单元格内边距 */
::v-deep(.el-table .el-table__cell) {
    padding: 0 8px !important;
}

/* 巡检类型下拉框 - 箭头在右侧，保持与文本对齐 */
.sp-input.small-select.right-arrow ::v-deep .el-input__inner {
    padding-right: 5px !important;
    text-align: left !important;
}

/* 确保下拉箭头在右侧 */
.sp-input.small-select.right-arrow ::v-deep .el-input__suffix {
    right: 0 !important;
}

.sp-input ::v-deep .el-input__inner,
.sp-input ::v-deep .el-textarea__inner {
    font-size: 12px;
    min-height: 30px !important;
    line-height: 15px !important;
    padding: 5px 0px !important;
    /* 输入框内边距左右改为2px，匹配单元格间距 */
    margin: 0 !important;
    /* 去除输入框额外外边距 */
    width: 100% !important;
    /* 输入框宽度铺满单元格 */
    box-sizing: border-box !important;
    /* 确保内边距不超出宽度 */
}

/* 下拉选择框适配 */
.sp-input ::v-deep .el-select .el-input__inner {
    padding-left: 0px !important;
    padding-right: 0px !important;
}

/* 日期选择器适配 */
.sp-input ::v-deep .el-date-editor .el-input__inner {
    padding: 0 0px !important;
    width: 100% !important;
}

/* 下拉选项样式适配 */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item {
    font-size: 12px !important;
    height: 30px !important;
    line-height: 30px !important;
    padding: 0 0px !important;
    /* 下拉选项左右内边距2px */
}

::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item:hover {
    font-size: 12px !important;
}

/* 小尺寸输入框特殊适配 */
.sp-input.small-input ::v-deep .el-input__inner {
    padding: 0 0px !important;
}

.sp-input.small-date-picker ::v-deep .el-date-editor .el-input__inner {
    width: 100% !important;
    padding: 0 0px !important;
}

.sp-input.small-select ::v-deep .el-select .el-input__inner {
    width: 100% !important;
    padding: 0 0px !important;
}

/* 确保备注列内容不会溢出到操作列下方 */
.remark-content {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
}

.search_label {
    width: 60px;
    font-size: 13px;
    margin-right: 20px;
    margin-left: 20px;
}

/* 固定列的单元格背景设为白色，确保完全覆盖下方内容 */
::v-deep(.el-table__fixed) {
    background-color: white !important;
    z-index: 3 !important;
    /* 提高z-index确保在最上层 */
}

/* 确保固定列的单元格边框完整 */
::v-deep(.el-table__fixed-right::before) {
    background-color: white !important;
    box-shadow: -1px 0 0 #EBEEF5 !important;
    /* 模拟边框，防止穿透 */
}

/* 确保表格横向滚动条出现时，固定列完全覆盖 */
::v-deep(.el-table__body-wrapper) {
    overflow-x: auto !important;
}

/* 确保固定列单元格的padding和内边距正常 */
::v-deep(.el-table__fixed .el-table__cell) {
    background-color: white !important;
    padding: 0 8px !important;
    box-shadow: none !important;
}
</style>
